__turbopack_context__.v({
  "badge": "LOvajq_badge",
  "createOption": "LOvajq_createOption",
  "dropdown": "LOvajq_dropdown",
  "inner": "LOvajq_inner",
});
